import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type TeamId = string | number;

function getTeamsHelper() {
  return clientApi.getOCClient().helpers.employer.teams;
}

function getPlaylistsHelper(teamId: TeamId) {
  return getTeamsHelper().id(teamId).playlists;
}

const { useFind: useTeamPlaylists, useCreate: useTeamPlaylistsCreation } = getCRUDHooks({
  entityName: 'teamPlaylist',
  find: ({ teamId, filters }) => getPlaylistsHelper(teamId).find(filters),
  create: (newPlaylist: any, { teamId }) => getPlaylistsHelper(teamId).create(newPlaylist),
});

export { useTeamPlaylists, useTeamPlaylistsCreation };
